var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21375 4.79651C7.06297 4.94728 6.97061 5.15681 6.97091 5.38692L6.97091 5.48819C6.97091 5.94899 7.34394 6.32203 7.80415 6.32144L12.3571 6.32144L4.65532 14.0232C4.33005 14.3485 4.33005 14.8764 4.65532 15.2017C4.98059 15.527 5.50856 15.527 5.83383 15.2017L13.5356 7.49995V12.0529C13.5356 12.5137 13.9086 12.8867 14.3688 12.8861H14.4701C14.9309 12.8861 15.3039 12.5131 15.3034 12.0529V5.38692C15.3034 4.92612 14.9303 4.55308 14.4701 4.55367L7.80415 4.55367C7.57375 4.55367 7.36452 4.64573 7.21375 4.79651Z",
    fill: "#34C759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.2813811aaf2f8231704c57ae6f173f59.svg";
export { ForwardRef as ReactComponent };